<template>
    <div class="container" v-if="loaded">
        <h2 class="title" v-if="$route.params.type === 'live'">{{$t('general.activityReport')}}</h2>
        <h2 class="title" v-else>{{$t('general.coverReport')}}</h2>
        <div class="date-controls" v-if="notEmpty">
            <div class="dates">
                <div class="picker-container">
                    <span class="active">{{$t('general.from')}}:</span>
                    <md-datepicker :md-disabled-dates="fromKeeper" md-immediately
                                   v-model="startDate">

                    </md-datepicker>
                </div>
                <div class="picker-container">
                    <span class="active">{{$t('general.to')}}:</span>
                    <md-datepicker :md-disabled-dates="gateKeeper" md-immediately
                                   v-model="endDate"></md-datepicker>
                </div>
            </div>
            <!--        <JsonCSV
                            :data="csvData"
                            class="csv-download"
                            :delimiter="delimiter"
                            name="activity.csv"

                    >
                        <img src="../../assets/images/download.svg">
                        {{$t('general.downloadCSV')}}
                    </JsonCSV>-->
            <button @click="downloadCSV" class="csv-download"><img src="../../assets/images/download.svg">
                {{$t('general.downloadCSV')}}
            </button>
            <VueMultiselect
                    :options="points"
                    :placeholder="$t('general.deviceSelect')"
                    :searchable="false"
                    :show-labels="false"
                    @input="callTable(tableFilter,startDate,endDate)"
                    class="device-select"
                    label="name"
                    track-by="id"
                    v-model="selectedPoint"
                    :allow-empty="false"
            >
            </VueMultiselect>
        </div>
        <div class="table-container" v-if="notEmpty">
            <div class="top">
                <button
                        :class="{active: tableFilter === 'daysHoursPeriod'}"
                        @click="callTable('daysHoursPeriod',startDate,endDate)"
                >
                    {{$t('general.daysHoursPeriod')}}
                </button>
                |
                <button
                        :class="{active: tableFilter === 'weeksDaysPeriod'}"
                        @click="callTable('weeksDaysPeriod',startDate,endDate)"
                >
                    {{$t('general.weeksDaysPeriod')}}
                </button>
                |
                <button
                        :class="{active: tableFilter === 'monthsDaysPeriod'}"
                        @click="callTable('monthsDaysPeriod',startDate,endDate)"
                >
                    {{$t('general.monthsDaysPeriod')}}
                </button>
            </div>
            <CountsTable :data="newTable" :translatable="translatable" v-if="loadedTable"></CountsTable>
            <Preloader v-else></Preloader>
        </div>
        <h2 class="title" v-else>{{$t('general.noDevices')}}</h2>
    </div>
    <Preloader v-else></Preloader>

</template>

<script>
import XLSX from 'xlsx';

import VueMultiselect from 'vue-multiselect/src/Multiselect';
import JsonCSV from 'vue-json-csv';
import CountsTable from '@/components/helpers/CountsTable';
import Preloader from '@/components/helpers/Preloader';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import 'vue-material/dist/vue-material.min.css';

const DataRepository = RepositoryFactory.get('data');
const DevicesRepository = RepositoryFactory.get('devices');

export default {
  name: 'Live',
  components: {
    VueMultiselect,
    CountsTable,
    Preloader,
    JsonCSV,
  },
  data() {
    return {
      selectedPoint: '',
      loaded: false,
      newTable: [],
      translatable: false,
      loadedTable: true,
      tableFilter: 'daysHoursPeriod',
      startDate: '',
      endDate: '',
      csvData: [],
      delimiter: this.$store.getters.delimiter,
      points: [],
      gateKeeper: (date) => {
        const blockedDate = new Date(this.startDate);
        blockedDate.setHours(0, 0, 0);
        const today = new Date().setHours(0, 0, 0);
        if (date < blockedDate || date > today) {
          return true;
        }

        return false;
      },
      fromBlocker: (date) => {
        const today = new Date();
        if (date > today) {
          return true;
        }
        return false;
      },
    };
  },
  watch: {
    startDate(newValue, oldValue) {
      const start = new Date(newValue);
      const end = new Date(this.endDate);
      if (start > end) {
        this.endDate = newValue;
      }
      this.callTable(this.tableFilter, newValue, this.endDate);
    },
    endDate(newValue, oldValue) {
      this.callTable(this.tableFilter, this.startDate, newValue);
    },
    groupId(newValue, oldValue) {
      this.getPoints(newValue).then(() => {
        this.callTable(this.tableFilter, this.startDate, this.endDate);
        this.loaded = true;
      });
    },
  },
  computed: {
    notEmpty() {
      return this.points.length > 0;
    },
    groupId() {
      return this.$store.getters.selectedGroup.id;
    },
  },
  async mounted() {
    this.$material.locale = {
      startYear: 1900,
      endYear: 2099,
      dateFormat: 'yyyy-MM-dd',
      firstDayOfAWeek: 0,
      days: this.$t('datepicker.days'),
      shortDays: this.$t('datepicker.shortDays'),
      shorterDays: this.$t('datepicker.shorterDays'),
      months: this.$t('datepicker.months'),
      shortMonths: this.$t('datepicker.shortMonths'),
      shorterMonths: this.$t('datepicker.shorterMonths'),
    };
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    const nextWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
    this.startDate = `${yyyy}-${mm}-${dd}`;
    this.endDate = `${nextWeek.getFullYear()}-${String(nextWeek.getMonth() + 1)
      .padStart(2, '0')}-${String(nextWeek.getDate())
      .padStart(2, '0')}`;
    await this.getPoints(this.$store.getters.selectedGroup.id);
    await this.callTable(this.tableFilter, this.startDate, this.endDate);
    this.loaded = true;
  },
  methods: {
    downloadCSV() {
      let filename = 'data.xls';
      if (this.$route.params.type === 'live') {
        filename = `activity_${this.selectedPoint.name}_${this.startDate}_${this.endDate}.xls`;
      } else {
        filename = `coverings_${this.selectedPoint.name}_${this.startDate}_${this.endDate}.xls`;
      }
      const wb = XLSX.utils.book_new();
      const sheet = XLSX.utils.json_to_sheet(this.csvData);
      XLSX.utils.book_append_sheet(wb, sheet);
      XLSX.writeFile(wb, filename);
    },
    callTable(type, dateFrom, dateTo) {
      this.loadedTable = false;
      this.tableFilter = type;
      if (type === 'monthsDaysPeriod') {
        this.translatable = true;
      } else {
        this.translatable = false;
      }
      if (this.selectedPoint) {
        if (this.$route.params.type === 'live') {
          DataRepository.getLiveData(this.$store.getters.token, this.selectedPoint.id, dateFrom, dateTo, type)
            .then((response) => {
              this.newTable = response;
              this.createCSV(response);
              this.loadedTable = true;
            });
        } else {
          DataRepository.getCoverData(this.$store.getters.token, this.selectedPoint.id, dateFrom, dateTo, type)
            .then((response) => {
              this.newTable = response;
              this.createCSV(response);
              this.loadedTable = true;
            });
        }
      }
    },
    createCSV(response) {
      const csvdata = [];
      let translateKey = '';
      switch (this.tableFilter) {
        case 'daysHoursPeriod':
          translateKey = '';
          break;
        case 'monthsDaysPeriod':
          translateKey = 'general.months.';
          break;
        default:
          translateKey = '';
          break;
      }
      Object.keys(response.rows).forEach((value, index) => {
        let dto = {};

        let attachTable = [];
        if (this.tableFilter === 'weeksDaysPeriod') {
          const translateObject = {};
          Object.keys(response.rows[value].countsData).forEach((v) => {
            translateObject[this.$t(`general.days.${v}`)] = response.rows[value].countsData[v];
          });
          attachTable = translateObject;
        } else {
          attachTable = response.rows[value].countsData;
        }
        dto = {
          [this.$t('csvHeaders.index')]: this.$t(`${translateKey}${value}`),
          [this.$t('csvHeaders.rowSummary')]: response.rows[value].rowSummary,
          [this.$t('csvHeaders.minTemp')]: response.rows[value].minTemp,
          [this.$t('csvHeaders.maxTemp')]: response.rows[value].maxTemp,
          ...attachTable,
        };

        csvdata.push(dto);
      });
      this.csvData = csvdata;
    },
    async getPoints(groupId) {
      this.loaded = false;
      if (this.$route.params.type === 'live') {
        this.points = await DevicesRepository.getDevicesWithShops(this.$store.getters.token, groupId);
        this.selectedPoint = this.points[0];
      } else {
        this.points = await DevicesRepository.deviceMap(this.$store.getters.token, groupId);
        this.selectedPoint = this.points[0];
      }
    },
  }
  ,
};
</script>

<style lang="scss" scoped>
    .csv-download {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: $peacock-blue;
        font-weight: bold;

        img {
            margin-right: 15px;
        }
    }

    .date-controls {
        display: flex;
        align-items: center;
        justify-content: space-between;


        @include media('<1025px') {
            flex-wrap: wrap;
        }
    }

    .device-select {
        max-width: 800px;
        @include media('<1025px') {
            width: 100%;
            max-width: unset;
        }
    }

    a {
        text-decoration: none;
        font-weight: bold;

        &:visited {
            color: #002678;
        }
    }

    button {
        cursor: pointer;
    }

    .switcheroo {
        align-items: center;
        display: flex;

        img {
            padding: 20px;
        }
    }

    .raptors-group {
        /*width: 100%;*/
        padding-left: 40px;
        padding-right: 55px;
        @include media('<1026px') {
            padding: 0;
        }
    }

    .top {
        margin-bottom: 20px;

        button {
            margin: 10px;
        }
    }

    .table-container {
        .top {
            margin-bottom: 20px;
            display: flex;
            padding: 25px;
            align-items: center;

            button {
                margin: 10px;
            }
        }
    }

    .charts-container, .table-container {
        background: white;
        border-radius: 5px;
        padding: 20px 0;
        margin-top: 50px;
        margin-bottom: 50px;

        .top {
            margin-bottom: 20px;
        }

        .controls {
            border-top: 1px solid #E5E5E5;
            border-bottom: 1px solid #E5E5E5;
            padding: 40px 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            @include media('<755px') {
                flex-direction: column;
            }
        }

        .charts {
            max-height: 320px;
            overflow-y: auto;
        }

    }

    .link {
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
            margin-right: 15px;
        }
    }

    h4 {
        font-size: rem(16px);
        font-weight: bold;
        // color: $baseTextColor;
        text-transform: uppercase;
        text-align: left;
        margin-left: 33px;
        margin-top: 0;
    }

    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #9e9e9e;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: #002678;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #9e9e9e;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #9e9e9e;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .date-control {
        /* color: #878a94; */
        font-size: rem(14px);
        font-weight: 900;
        display: flex;
        flex-wrap: wrap;
        align-items: center;

    }

    button {
        background: none;
        border: none;
        font-size: rem(14px);
        font-weight: 900;
        /* color: #878a94; */
        color: inherit;

    }

    .table {
        box-shadow: none;
    }

    .table-container {
        box-shadow: 0 5px 6px $baseShadow;
        overflow: auto;

        .top {
            button {
                text-transform: uppercase;
            }

            border-bottom: 1px solid #e5e5e5;
        }

        .tr {
            .td {
                padding: 13px;
            }

            &:first-child {
                .td {
                    border: none;
                    border-bottom: 1px solid $border-blue;
                    font-weight: bold;
                }
            }

            &:not(:last-child) {
                .td {
                    vertical-align: middle;
                    // border: 1px solid $border-gray;
                    border-bottom: 1px solid $border-gray;

                    &:first-child {
                        border-left: none;
                        border-right: 1px solid $border-gray;
                    }

                    &:nth-last-child(-n+4) {
                        border-right: none;
                        border-left: 1px solid $border-gray;

                    }

                    .weather-container {
                        display: flex;
                        justify-content: center;

                        img {
                            width: 45px;
                        }
                    }

                }
            }


            &:last-child {
                font-weight: bold;

                .td {
                    padding: 13px 0;
                    border-bottom: 1px solid $border-gray;

                    &:first-child, &:last-child {
                        border-right: 1px solid $border-gray;

                    }
                }
            }
        }
    }

    .link.download {
        > div {
            display: flex;
            align-items: center;
            cursor: pointer;
        }
    }

    .link.print {
        cursor: pointer;
    }


    .picker-container {
        display: flex;
        align-items: center;
        color: $peacock-blue !important;

        input {
            color: $peacock-blue !important;
        }

    }

    .active {
        color: $peacock-blue;
        font-weight: 900;
    }

    .dates {
        display: flex;
        flex-direction: row;
    }

    .csv-download {
        cursor: pointer;
    }

    .container {
        background-color: transparent;
    }
</style>
